import React from "react";
import newLogo from "../newLogo.jpeg";

const Footer = () => {
  const quickLinks = [
    { name: "About Us", id: "about" },
    { name: "Services", id: "services" },
    { name: "Solutions", id: "solutions" },
    { name: "Case Studies", id: "case-studies" },
    { name: "Insights", id: "insights" },
  ];
  const serviceLinks = [
    "Digital Consulting",
    "Software Development",
    "Process Automation",
    "Innovation Lab",
    "Training",
  ];

  return (
    <footer style={{ backgroundColor: "#0C1A36", padding: "64px 0" }}>
      <div className="container">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "48px",
          }}
        >
          <div className="footer-brand" style={{ gridColumn: "span 1" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginBottom: "24px",
              }}
            >
              <img
                src={newLogo}
                alt="IngeniousTech Logo"
                style={{ height: "90px", width: "180" }}
              />
              <span
                style={{ fontWeight: "bold", fontSize: "20px", color: "white" }}
              >
                Ingenious<span style={{ color: "#1746A2" }}>Tech</span>
              </span>
            </div>
            <p
              style={{
                color: "#9ca3af",
                marginBottom: "24px",
                maxWidth: "400px",
                lineHeight: 1.6,
              }}
            >
              Empowering businesses through intelligent digital solutions that
              unlock efficiency and improve performance.
            </p>
            <div style={{ display: "flex", gap: "16px" }}>
              {["linkedin-in", "twitter", "facebook-f"].map((social, index) => (
                <a
                  key={index}
                  href="#"
                  style={{
                    width: "40px",
                    height: "40px",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    transition: "background-color 0.3s",
                  }}
                >
                  <i className={`fab fa-${social}`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4
              style={{
                fontWeight: "bold",
                color: "white",
                marginBottom: "16px",
              }}
            >
              Quick Links
            </h4>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {quickLinks.map((link, index) => (
                <li key={index} style={{ marginBottom: "12px" }}>
                  <a
                    href={`#${link.id}`}
                    style={{
                      color: "#9ca3af",
                      textDecoration: "none",
                      transition: "color 0.3s",
                    }}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4
              style={{
                fontWeight: "bold",
                color: "white",
                marginBottom: "16px",
              }}
            >
              Services
            </h4>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {serviceLinks.map((link, index) => (
                <li key={index} style={{ marginBottom: "12px" }}>
                  <a
                    href="#services"
                    style={{
                      color: "#9ca3af",
                      textDecoration: "none",
                      transition: "color 0.3s",
                    }}
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div
          className="footer-bottom"
          style={{
            borderTop: "1px solid rgba(255, 255, 255, 0.1)",
            marginTop: "48px",
            paddingTop: "32px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <p style={{ color: "#9ca3af", fontSize: "14px", margin: 0 }}>
            © 2024 Ingenious Tech & Consulting Solutions. All rights reserved.
          </p>
          <div style={{ display: "flex", gap: "24px", fontSize: "14px" }}>
            <a href="#" style={{ color: "#9ca3af", textDecoration: "none" }}>
              Privacy Policy
            </a>
            <a href="#" style={{ color: "#9ca3af", textDecoration: "none" }}>
              Terms of Service
            </a>
          </div>
        </div>
      </div>

      <style>{`
                @media (min-width: 768px) {
                    .footer-brand { grid-column: span 2 !important; }
                    .footer-bottom { flex-direction: row !important; justify-content: space-between !important; }
                }
            `}</style>
    </footer>
  );
};

export default Footer;
